module.exports = __webpack_public_path__ + "static/img/sidebar_bg.e56fbc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sidebar_bg.png
// module id = K2cY
// module chunks = 1